import React from 'react';
import { Link } from 'react-router-dom';

import logo from 'assets/images/Backoffice/logo-new.svg';
import homeLink from 'assets/images/homeLink.svg';
import homeLinkMobile from 'assets/images/homeLinkMobile.svg';

export default function HomeHeader() {
  return (
    <header className="header">
      <nav className="header-nav">
        <div className="header-logo">
          <strong className="logo">
            <Link to="/financial-eor-compliance">
              <img src={logo} alt="logo" />
            </Link>
          </strong>
        </div>

        <ul className="header-menu-box header--list">
          <li>
            <div className="header-menu-wrapp">
              <span className="header-list-opener">
                <span className="icon icon-hamburger" />
              </span>
              <ul className="header-list">
                <li>
                  <Link to="/accounting-financial-payroll">
                    End-to-End Funding
                  </Link>
                </li>
                <li>
                  <Link to="/eor-employer-of-record-services">Turnkey EOR</Link>
                </li>
                <li>
                  <Link to="/business-compliance-services">
                    Dependable Compliance
                  </Link>
                </li>
              </ul>
            </div>
          </li>
        </ul>

        <ul className="header-menu-box ml-a">
          <li>
            <Link to="/">
              <img
                src={homeLink}
                className="hidden-sm-down header-home"
                alt="logo"
              />
              <img
                src={homeLinkMobile}
                className="hidden-sm-up header-home"
                alt="logo"
              />
            </Link>
          </li>

          <li>
            <a
              href={`${process.env.REACT_APP_BACKOFFICE_URL}/login`}
              className="header-menu-opener"
            >
              <i className="icon icon-login" />
              <span>Member Login</span>
            </a>
          </li>

          <li>
            <a
              href={`${process.env.REACT_APP_BACKOFFICE_URL}/registration`}
              className="header-menu-opener"
            >
              <i className="icon icon-add-list" />
              <span>Register</span>
            </a>
          </li>
        </ul>
      </nav>
    </header>
  );
}
